import { AxiosError } from 'axios'

export function isAxiosError(error: any): error is AxiosError {
  if (!error) {
    return false
  }

  return (error as AxiosError).isAxiosError !== undefined
}
